module.exports = __webpack_public_path__ + "7b622c052471a17a45f070dfc5e73d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/wechat.png
// module id = 446
// module chunks = 0